import apiFetch from '../apiFetch'

export default function (token, operationTypeId, organizativeUnitId, dossierSubtypeId) {
  return apiFetch({ endPoint: `OperationTypes/${operationTypeId}/SaleTypes?organizedUnitId=${organizativeUnitId}&dossierSubtypeId=${dossierSubtypeId}`, method: 'GET', body: null, token: token })
}
